export default __webpack_public_path__ + "static/media/people-celebrating.903fa20c.png";